var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgChevronDown = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M9.46875 14.5313C9.7625 14.8251 10.2375 14.8251 10.5281 14.5313L16.5312 8.53135C16.825 8.2376 16.825 7.7626 16.5312 7.47197C16.2375 7.18135 15.7625 7.17822 15.4719 7.47197L10.0031 12.9407L4.53125 7.46885C4.2375 7.1751 3.7625 7.1751 3.47187 7.46885C3.18125 7.7626 3.17812 8.2376 3.47187 8.52822L9.46875 14.5313Z",
  fill: "currentColor"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgChevronDown);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "7e8c51a7d1b6a0dfdada9d091fa7194e.svg";